<app-common-header></app-common-header>
<main role="main" class="maincnt quest">
  <div class="getbannersect pb-2">
    <div class="sectpad container-fluid">
      <div class="col-sm-12 p-0">
        <div class="col-12 text-center webview"> <img src="assets/images/logo-charcoal.png" class="signimg" /></div>
        <div class="col-sm-12 p-0 mt-5">
          <a href="javascript:void(0)" *ngIf="showBack" class="backbtn webview" (click)="back();"></a>
          <div id ="container">
            <ng-template appCommercial></ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<div class="btm-process webview">
  <div class="text-center">
    <span><img src="assets/images/commercialactivetower.png" style="margin-top:0px !important;"></span>
    <span *ngIf="!showThunder"><img src="assets/images/disablethunder.png" id="thunder001"></span>
    <span *ngIf="showThunder"><img src="assets/images/commercialactivethunder.png" id="thunder001"></span>
    <span><img src="assets/images/disabledot.png" id="dot002"></span>
    <span><img src="assets/images/disabledot.png" id="dot003"></span>
    <span><img src="assets/images/disabledot.png" id="dot004"></span>
    <span><img src="assets/images/disabledot.png" id="dot005"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder006"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot007"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot008"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot009"></span>
    <span *ngIf="showNextId">
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0012"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0013"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0014"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0015"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0016"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0017"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0019"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0020"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0021"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0022"></span>
    <span class="disableimg"><img src="assets/images/disablebuilding.svg" class="buildimg" id="building"></span>
  </span>
  <span *ngIf="!showNextId">
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0010"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0011"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0015"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0016"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0017"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0019"></span>
    <span class="disableimg thunder"><img src="assets/images/disablethunder.png" id="thunder0020"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0021"></span>
    <span class="disableimg"><img src="assets/images/disabledot.png" id="dot0022"></span>
    <span class="disableimg"><img src="assets/images/disablebuilding.svg" class="buildimg" id="building"></span>
  </span>
  </div>
</div>